import { useBasicABTest } from '@bridebook/web/app-basic/lib/ab-tests/hooks/use-basic-ab-test';

/**
 * Hooks exported here are imported and initialized in `useGlobalABTests` hook
 */

export const globalABTests: ((...args: any) => ReturnType<typeof useBasicABTest>)[] = [
  // add init hooks for global tests here
];
